import { twMerge } from 'tailwind-merge'
import { StagedActionMarkdown, type StagedActionAttachment } from '@renderer/chat/integrations/staged-action'

interface ActionContentPreviewProps {
  content: string
  className?: string
  attachments?: Array<StagedActionAttachment>
  /** Clamp height with a fade-out mask (preview truncation). Disable to hug content. */
  clamp?: boolean
  /** Match the typography used by the chat output body. */
  outputTypography?: boolean
}

export function ActionContentPreview({
  content,
  className,
  attachments,
  clamp = true,
  outputTypography = false,
}: ActionContentPreviewProps) {
  return (
    <div
      className={twMerge(
        'relative whitespace-normal',
        clamp &&
          'max-h-[3.9375rem] overflow-hidden [-webkit-mask-image:linear-gradient(to_bottom,black_55%,transparent_100%)] [mask-image:linear-gradient(to_bottom,black_55%,transparent_100%)]',
        className,
      )}
    >
      <StagedActionMarkdown
        size={outputTypography ? 'md' : 'sm'}
        attachments={attachments}
        className={outputTypography ? undefined : 'text-foreground-secondary'}
      >
        {content}
      </StagedActionMarkdown>
    </div>
  )
}
